export default "__VITE_ASSET__DLXcThRS__"